import React, { useEffect, useRef, useState } from "react";
import { ShieldCheck, Delete } from "lucide-react";
import { Dialog, DialogContent } from "./ui/dialog";

const GATE_CODE = "13121990";
const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", "del"];

export default function AdminGate({ open, onOpenChange, onUnlock }) {
  const [code, setCode] = useState("");
  const [shake, setShake] = useState(false);
  const timer = useRef(null);

  useEffect(() => { if (open) setCode(""); }, [open]);

  useEffect(() => {
    if (code.length !== GATE_CODE.length) return;
    if (code === GATE_CODE) { onUnlock(); return; }
    setShake(true);
    timer.current = setTimeout(() => { setShake(false); setCode(""); }, 500);
    return () => clearTimeout(timer.current);
  }, [code, onUnlock]);

  const press = (k) => {
    if (k === "del") setCode((c) => c.slice(0, -1));
    else if (k && code.length < GATE_CODE.length) setCode((c) => c + k);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[320px] p-0 overflow-hidden border-0 bg-[#0b0b0b] text-white" data-testid="admin-gate">
        <div className="relative px-6 pt-7 pb-6">
          <div className="pointer-events-none absolute -top-16 left-1/2 -translate-x-1/2 h-40 w-40 rounded-full bg-[#f5b400]/15 blur-3xl" />
          <div className="relative flex flex-col items-center">
            <span className="grid place-items-center h-11 w-11 rounded-full bg-gradient-to-br from-[#f5b400] to-[#b07a00] text-black shadow-[0_0_18px_rgba(245,180,0,0.5)]">
              <ShieldCheck className="h-5 w-5" />
            </span>
            <h3 className="mt-3 font-display font-extrabold text-base uppercase tracking-[0.18em] text-[#f5b400]">Restricted</h3>
            <p className="text-[11px] text-zinc-500 mt-1">Enter the 8-digit passcode</p>

            <div className={`mt-5 flex items-center gap-2.5 ${shake ? "animate-[gate-shake_0.4s_ease-in-out]" : ""}`} data-testid="admin-gate-dots">
              {Array.from({ length: GATE_CODE.length }).map((_, i) => (
                <span key={i} className={`h-3 w-3 rounded-full transition-[background-color,box-shadow] ${
                  i < code.length ? (shake ? "bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.8)]" : "bg-[#f5b400] shadow-[0_0_8px_rgba(245,180,0,0.8)]") : "bg-white/10 ring-1 ring-white/15"}`} />
              ))}
            </div>

            <div className="mt-6 grid grid-cols-3 gap-2.5 w-full">
              {KEYS.map((k, i) => (
                k === "" ? <span key={i} /> : (
                  <button key={k} type="button" onClick={() => press(k)} data-testid={`admin-gate-key-${k}`}
                    className="h-12 rounded-xl bg-white/[0.05] ring-1 ring-white/10 text-white font-display font-bold text-lg grid place-items-center hover:bg-white/10 active:scale-95 active:bg-[#f5b400]/20 transition-[transform,background-color]">
                    {k === "del" ? <Delete className="h-5 w-5 text-zinc-400" /> : k}
                  </button>
                )
              ))}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
